import { render, staticRenderFns } from "./shopPage.vue?vue&type=template&id=f81c80d6&scoped=true&"
import script from "./shopPage.vue?vue&type=script&lang=ts&"
export * from "./shopPage.vue?vue&type=script&lang=ts&"
import style0 from "./shopPage.vue?vue&type=style&index=0&id=f81c80d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81c80d6",
  null
  
)

export default component.exports